/**
 * Created By Vision CLI
 * Issues and merge requests are welcomed：https://git.code.oa.com/impage/vision
 *
 * API 参考：
 * http://vision.oa.com/docs/dev-component/#
 */
import React, { useEffect, useState } from 'react';
import { connect, Provider, useDispatch, useSelector } from 'react-redux';
import { isMQQ } from '@tencent/h5-env-enhance';
import { updateCurPageAction, updateHistoryLengthInfo, } from '../../lib/common/store/reducer/actions';
import store from '../../lib/common/store/store';
import { reportBtnClick, reportPV } from '../../lib/utils/beacon';
import styles from './index.module.scss';
const PageContainer = function ({ data, // {object} “数据”表单内容
commonStyle, // {object} “组件自定义样式”表单内容
meta, // {object} 页面元数据
children, }) {
    const { visible, pageId, imgUrl, bgColor, isReportPV, isNeedRoute } = data;
    const dispatch = useDispatch();
    const curPage = useSelector(store => store.base.curPage);
    const curHistory = useSelector(store => store.base.historyLength);
    const [isShow, setShowStatus] = useState(visible && curPage === pageId);
    useEffect(() => {
        var _a, _b, _c, _d;
        console.log('check qq and open share icon');
        if (isMQQ()) {
            console.log('try show begin');
            console.log((_a = window.mqq) === null || _a === void 0 ? void 0 : _a.invoke);
            (_b = window.mqq) === null || _b === void 0 ? void 0 : _b.invoke('ui', 'setWebViewBehavior', {
                actionButton: 1,
            });
            (_d = (_c = window === null || window === void 0 ? void 0 : window.mqq) === null || _c === void 0 ? void 0 : _c.ui) === null || _d === void 0 ? void 0 : _d.setWebViewBehavior({
                actionButton: 1,
            });
            console.log('try show end');
        }
    }, []);
    useEffect(() => {
        // 仅在编辑器模式下使用visible属性, 正式发布情况下默认都不展示
        if (meta.isEditor && visible !== isShow) {
            setShowStatus(visible);
        }
    }, [visible]);
    useEffect(() => {
        if (curPage === pageId) {
            setShowStatus(true);
            if (isNeedRoute) {
                window.history.pushState(null, null, `#${curPage}`);
                dispatch(updateHistoryLengthInfo(curHistory + 1));
            }
        }
        else {
            setShowStatus(false);
        }
        if (!isReportPV) {
            return;
        }
        // PV上报
        if (curPage && curPage === pageId) {
            reportPV(pageId);
        }
    }, [curPage]);
    const handleHasChange = () => {
        // hash 变化后返回首页
        if (!curHistory) {
            return;
        }
        const { hash } = window.location;
        if (hash !== 'index') {
            // 需要跳转到首页
            window.history.go(-curHistory);
            dispatch(updateHistoryLengthInfo(0));
            dispatch(updateCurPageAction('index'));
        }
    };
    useEffect(() => {
        if (!isNeedRoute) {
            return;
        }
        window.addEventListener('hashchange', handleHasChange);
    }, [curHistory]);
    /**
     * 注册当前页面的按钮点击上报事件, 仅在当前页面可见情况下上报
     */
    useEffect(() => {
        const globalOnClickHandler = (e) => {
            var _a;
            if (!curPage || curPage !== pageId)
                return;
            const target = e.target;
            // 按钮点击event
            const btnId = (_a = target === null || target === void 0 ? void 0 : target.dataset) === null || _a === void 0 ? void 0 : _a.btnId;
            if (btnId) {
                reportBtnClick(btnId);
            }
        };
        document.addEventListener('click', globalOnClickHandler, false);
        return () => {
            document.removeEventListener('click', globalOnClickHandler, false);
            window.removeEventListener('hashchange', handleHasChange);
        };
    }, []);
    if (!isShow)
        return React.createElement("div", null);
    const pageStyle = {
        display: isShow ? 'flex' : 'none',
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: '9999',
        flexDirection: 'column',
        overflow: 'hidden',
        overflowY: 'scroll',
        backgroundColor: bgColor || 'unset',
    };
    const contentStyle = {
        height: 'inherit',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundImage: `url(${imgUrl})`,
    };
    return (React.createElement("div", { style: Object.assign(Object.assign({}, commonStyle), pageStyle) },
        React.createElement("div", { className: styles.content, style: imgUrl ? contentStyle : {} }, React.Children.map(children, child => (React.createElement("div", { "data-key": `${pageId}-${child.key}`, className: styles['content-index'] }, child))) || React.createElement("div", null))));
};
const ConnectedPageContainer = connect()(PageContainer);
export default (props) => (React.createElement(Provider, { store: store },
    React.createElement(ConnectedPageContainer, Object.assign({}, props))));
